import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";
import { coastDistanceColors } from "../util/colors";

export const DistanceToTheNearestCoastLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle as React.CSSProperties}>
      <div>
        <b>{t("legend.distanceToTheNearestCoast")}</b>
      </div>

      {coastDistanceColors.map(([value, r, g, b, a, label]) => (
        <div key={value}>
          <span style={legendItemStyle(`rgba(${r}, ${g}, ${b}, ${Number(a) / 255})`)}></span>
          {label} km
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.distanceToTheNearestCoast")}
        </span>
      </div>
    </div>
  );
};
